import script from "./TestimonialsComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestimonialsComp.vue?vue&type=script&setup=true&lang=ts"

import "./TestimonialsComp.vue?vue&type=style&index=0&id=7145680e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7145680e"]])

export default __exports__